import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Assuming you use react-router-dom
import { Typography, Box, CircularProgress, Alert } from '@mui/material';
// import axios from 'axios'; // Not used in the current logic, can be removed if not verifying session
import { API_BASE_URL } from '../config'; // Import API_BASE_URL (though not directly used in current logic)
import type { AppUser } from '../types'; // Import shared AppUser type

// const API_BASE_URL = 'https://myhome.cfc.io/api/unitai'; // Removed, now imported

const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = React.useState('Processing your subscription...');
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');

    if (sessionId) {
      // OPTIONAL: Verify session with backend and update user status more robustly
      // This provides immediate feedback, but webhook is the source of truth for DB updates.
      // For now, we'll assume the webhook will handle DB changes and just update localStorage
      // to give the main App.tsx an immediate hint.

      console.log('Payment successful! Session ID:', sessionId);
      setMessage('Payment successful! Your subscription is being activated.');
      
      // Update localStorage to indicate active subscription (simplistic approach)
      // A more robust solution might involve fetching updated user from backend here
      // or relying purely on webhook + App.tsx refetching apiKeyStatus.
      try {
        const storedUserString = localStorage.getItem('unitaiUser');
        if (storedUserString) {
          const user: AppUser = JSON.parse(storedUserString);
          user.subscriptionStatus = 'active'; // Tentatively set to active
          localStorage.setItem('unitaiUser', JSON.stringify(user));
          console.log('Updated unitaiUser in localStorage with active subscription status.');
        }
      } catch (e) {
        console.error("Could not update user in localStorage:", e);
      }
      setLoading(false);

      // Redirect back to home/dashboard after a short delay
      setTimeout(() => {
        navigate('/'); // Or your main dashboard path
      }, 3000); // 3-second delay

    } else {
      setMessage('No session ID found. Payment status unclear.');
      setError('Could not confirm payment success due to missing session ID.');
      setLoading(false);
      setTimeout(() => {
        navigate('/'); 
      }, 5000);
    }
  }, [location, navigate]);

  return (
    <Box sx={{ textAlign: 'center', mt: 8 }}>
      <Typography variant="h4" gutterBottom>
        Subscription Status
      </Typography>
      {loading && <CircularProgress sx={{my: 3}}/>}
      {!loading && error && <Alert severity="error">{error}</Alert>}
      {!loading && !error && <Alert severity="success">{message}</Alert>}
      <Typography sx={{mt: 2}}>You will be redirected shortly...</Typography>
    </Box>
  );
};

export default PaymentSuccessPage; 